import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "title", label: "Titre", required: true },
  { key: "date", label: "Date / période", required: true, placeholder: "Ex : Décembre 2025" },
  { key: "category", label: "Catégorie", required: true, placeholder: "Collecte, Maraude…" },
  { key: "description", label: "Description", type: "textarea" },
  { key: "image", label: "Image (URL)", type: "image" },
];

export default function AdminRealisations() {
  return (
    <AdminCrud
      title="Réalisations"
      description="Les événements et actions passées affichés sur la page « Nos réalisations »."
      addLabel="Ajouter une réalisation"
      table="realisations"
      fields={fields}
      listTitleKey="title"
      listSubtitleKey="category"
      listImageKey="image"
    />
  );
}